import Grid from '@mui/material/Grid';
import { TotalsProps } from '../../../../../pages/dashboard/tradedocuments/tradeDocumentTypes/parkinglistTypes';
import CustomTextField from '../../../../CustomTextInput';

const Totals = ({
    totalUnitQuantity,
    totalNetWeight,
    totalGrossWeight,
    totalVolume
}: TotalsProps) => {
    return (
        <div className='lg:border lg:border-appcolorgreyfaint lg:px-[1rem] lg:pt-[1.1rem] lg:pb-4'>
            <Grid
                container
                spacing={1}
                sx={{
                    marginTop: '0px'
                }}
            >
                <Grid item xs={12} md={12} lg={3}>
                    <CustomTextField
                        disabled
                        id='commercialinvoice-totalUnit'
                        label='Total Unit Qty'
                        name='totalUnit'
                        value={totalUnitQuantity}
                    />
                </Grid>

                <Grid item xs={12} md={12} lg={3}>
                    <div className='mt-4 lg:mt-0'>
                        <CustomTextField
                            disabled
                            id='commercialinvoice-totalNetWeight'
                            label='Total net weight (kg)'
                            name='totalNetWeight'
                            value={totalNetWeight}
                        />
                    </div>
                </Grid>

                <Grid item xs={12} md={12} lg={3}>
                    <div className='mt-4 lg:mt-0'>
                        <CustomTextField
                            disabled
                            id='commercialinvoice-totalGrossWeight'
                            label='Total gross weight (kg)'
                            name='totalGrossWeight'
                            value={totalGrossWeight}
                        />
                    </div>
                </Grid>

                <Grid item xs={12} md={12} lg={3}>
                    <div className='mt-4 lg:mt-0'>
                        <CustomTextField
                            disabled
                            value={totalVolume}
                            id='commercialinvoice-totalVolume'
                            label='Total volume (m³)'
                            name='totalVolume'
                        />
                    </div>
                </Grid>
            </Grid>
        </div>
    );
};

export default Totals;
